// extracted by mini-css-extract-plugin
module.exports = {"publikumsmottak":"Reception_publikumsmottak__sCBN2","header":"Reception_header__6tVyN"};